import { ReactElement, useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

import { QueryActionFormInputs } from "../types/form-inputs.ts";
import { CardLayout } from "./CardLayout.tsx";
import { Table } from "./catalyst/Table.tsx";
import { TableBody } from "./catalyst/TableBody.tsx";
import { TableHead } from "./catalyst/TableHead.tsx";
import { TableHeader } from "./catalyst/TableHeader.tsx";
import { TableRow } from "./catalyst/TableRow.tsx";
import EntityMappingRow from "./EntityMappingRow.tsx";

const SingleEntityMappingTable = (): null | ReactElement => {
  const { control } = useFormContext<QueryActionFormInputs>();
  const { append, fields } = useFieldArray({
    control,
    name: "entityMappings",
  });
  if (fields.length > 1) {
    throw new Error(
      "SingleEntityMappingTable must only contain one entity mapping row.",
    );
  }

  useEffect(() => {
    if (fields.length === 0) {
      append({
        entityQualifiedName: "",
        isPersisted: false,
        isRoot: false,
        liquidTemplate: "",
        outputIsJson: false,
        relationship: "",
        value: "",
      });
    }
  }, [append, fields.length]);

  const entity = fields[0];

  return (
    <CardLayout
      header={
        <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
          <div className="ml-4 mt-2">Local Action Mapping</div>
        </div>
      }
    >
      <Table className="w-full table-fixed" dense>
        <TableHead>
          <TableRow>
            <TableHeader className="w-10 text-left" />
            <TableHeader className="w-1/4">Output Entity Type</TableHeader>
            <TableHeader className="w-1/4">Liquid Template</TableHeader>
            <TableHeader className="w-1/4">Preview Value</TableHeader>
            <TableHeader className="w-1/6">Edge Relationship</TableHeader>
            <TableHeader className="w-10 text-right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {entity && (
            <EntityMappingRow entity={entity} index={0} key={entity.id} />
          )}
        </TableBody>
      </Table>
    </CardLayout>
  );
};

export default SingleEntityMappingTable;
